import React from 'react';
import { Check, X, Scale, Network } from 'lucide-react';
import { motion } from 'framer-motion';
import { OfferBlock } from './OfferBlock';
export function Pricing() {
  const comparison = [{
    bad: 'Armás cada anamnesis desde cero',
    good: 'Plantilla lista por franja etaria'
  }, {
    bad: 'Horas redactando cada informe',
    good: 'Modelo completo en minutos'
  }, {
    bad: 'Consentimientos improvisados',
    good: '5 modelos según situación familiar'
  }, {
    bad: 'Cero registro de evolución',
    good: 'Planillas de seguimiento incluidas'
  }, {
    bad: 'Miedo a la exposición legal',
    good: 'Tomo completo de blindaje legal'
  }, {
    bad: 'Traducís todo para la escuela',
    good: 'Modelos de informe listos'
  }, {
    bad: 'Protocolos armados caso por caso',
    good: 'Protocolos por cuadro, listos para aplicar'
  }];
  return <section className="py-10 md:py-20 bg-sky-50/50" data-id="element-136">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-137">
        {/* Comparison Table */}
        <div className="max-w-4xl mx-auto mb-16 md:mb-24" data-id="element-138">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 md:mb-10" data-id="element-139">
            ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
          <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-140">
            <div className="grid grid-cols-2 bg-slate-100 border-b border-slate-200" data-id="element-141">
              <div className="p-3 md:p-6 text-center font-bold text-slate-500 text-xs md:text-base" data-id="element-142">
                Sin el sistema
              </div>
              <div className="p-3 md:p-6 text-center font-bold text-blue-700 bg-blue-50 text-xs md:text-base" data-id="element-143">
                Con el sistema
              </div>
            </div>
            {comparison.map((row, i) => <motion.div initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} key={i} className="grid grid-cols-2 border-b border-slate-100 last:border-0 hover:bg-slate-50/50 transition-colors" data-id="element-144">
                <div className="p-3 md:p-6 flex items-start gap-2 md:gap-3 text-slate-600" data-id="element-145">
                  <X className="w-4 h-4 md:w-5 md:h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-146" />
                  <span className="text-xs md:text-base" data-id="element-147">{row.bad}</span>
                </div>
                <div className="p-3 md:p-6 flex items-start gap-2 md:gap-3 bg-blue-50/30 font-medium text-slate-900" data-id="element-148">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-149" />
                  <span className="text-xs md:text-base" data-id="element-150">{row.good}</span>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Offer (tiers + trust badges) */}
        <div id="oferta" className="scroll-mt-6 mb-12 md:mb-20" data-id="element-151">
          <OfferBlock heading="OFERTA DE LANZAMIENTO" data-id="element-152" />
        </div>

        {/* Edicion Total Details */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto bg-white rounded-3xl p-6 md:p-10 border border-slate-200 shadow-sm" data-id="element-153">
          <h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-2 md:mb-3 text-center" data-id="element-154">
            ¿QUÉ AGREGA LA EDICIÓN TOTAL?
          </h3>
          <p className="text-sm md:text-base text-center text-slate-600 mb-5 md:mb-8" data-id="element-155">
            Para quienes reciben casos con exposición legal o necesitan
            articular con otros actores
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5" data-id="element-156">
            <div className="bg-slate-50 p-4 md:p-5 rounded-2xl hover:bg-blue-50/50 transition-colors flex gap-3" data-id="element-157">
              <span className="flex-shrink-0 w-10 h-10 bg-blue-100 text-blue-700 rounded-lg flex items-center justify-center" data-id="element-158">
                <Scale className="w-5 h-5" data-id="element-159" />
              </span>
              <div className="min-w-0" data-id="element-160">
                <h4 className="font-bold text-slate-900 text-sm md:text-base leading-tight mb-1 flex items-center gap-1.5" data-id="element-161">
                  <span className="text-[10px] font-bold text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded" data-id="element-162">
                    T7
                  </span>
                  Aspectos Legales
                </h4>
                <p className="text-[11px] md:text-xs text-slate-600 leading-snug" data-id="element-163">
                  Modelos por situación familiar, protocolo de secreto
                  profesional y guía ante pedidos judiciales.
                </p>
              </div>
            </div>
            <div className="bg-slate-50 p-4 md:p-5 rounded-2xl hover:bg-blue-50/50 transition-colors flex gap-3" data-id="element-164">
              <span className="flex-shrink-0 w-10 h-10 bg-blue-100 text-blue-700 rounded-lg flex items-center justify-center" data-id="element-165">
                <Network className="w-5 h-5" data-id="element-166" />
              </span>
              <div className="min-w-0" data-id="element-167">
                <h4 className="font-bold text-slate-900 text-sm md:text-base leading-tight mb-1 flex items-center gap-1.5" data-id="element-168">
                  <span className="text-[10px] font-bold text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded" data-id="element-169">
                    T8
                  </span>
                  Trabajo Interdisciplinario
                </h4>
                <p className="text-[11px] md:text-xs text-slate-600 leading-snug" data-id="element-170">
                  Modelos de derivación e informe para escuela, EOE,
                  psiquiatría, psicopedagogía y fonoaudiología.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}